<template>
  <popup ref="popup"  :appendToBody="true">
    <div slot="body">
      <el-form class="dataForm" ref="form"  :model="formParameter" :inline="true" label-width="80px"
        :rules="rules">
        <el-row>
          <el-col :span="16">
            <el-form-item label="标题" prop="title">
              <el-input  :readonly="true" v-model="formParameter.title" autocomplete="off"
                placeholder="标题"></el-input></el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="科目" prop="duration">
                  <el-input  placeholder="请选择科目" :readonly="true" v-model="sbname">
                </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            授课笔记
            <hr>
            <el-form-item prop="remarks">
              <span  v-html="formParameter.remarks"></span>
  
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    
    </div>
    <div slot="footer">
      <el-button @click="close">关 闭</el-button>
    </div>
  </popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue'
import api from '@/api/edu/videoes/videoes.js'
import examApi from '@/api/exams/exampaper/exampaper.js'
import subApi from '@/api/edu/subject/subject.js'
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue'
import wangEdit from "@/components/wangEdit/wangEditLess.vue";
import tree from '@/components/tree/tree.vue'

export default {
  name: 'edit',
  components: {
    popup,
    selectOptionDictionary,
    wangEdit,
    tree
  },
  data() {
    return {
      type: '2',
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: { vsite: 1 },

      sbname: '', //科目名称
      dialogVisible: false, //科目弹框开关
      subData: [], //选中的科目信息
      //---树--选择题型 模态框弹出为false
      innerVisible: false,
      // 树 的最后一个的id集
      subIds: [],
      subjectList: null,
      orgsubjectList: null,

      wangEditisupdt:false,

      listExam: [],
      rules: {
       
      
      }
    }
  },
  methods: {
    // 选择科目
    selectSub() {
      this.dialogVisible = true

      if (!this.orgsubjectList) {
        subApi.list({}, response => {
          this.orgsubjectList = response.data
          this.subjectList = this.orgsubjectList
        })
      } else {
        this.subjectList = this.orgsubjectList
      }

    },
    // 选择科目
    treeClick(data) {
      this.subData = data
    },
  
    //打开弹框
    open(parameter,   disabled, size) {

      this.wangEditisupdt = true
      this.type = parameter.type
      let title =  "查看 - " + (this.type == 3 ? '课堂笔记' : '代码附件')
      this.parameter = parameter
      this.disabled = disabled
      this.$refs.popup.open(title, size)

      setTimeout(()=>{
				this.wangEditisupdt = false
			    },100)

      this.$nextTick(() => {
        this.init()
      })
    },
    //关闭弹框
    close() {
      this.sbname = ""
      this.formParameter = { vsite: 1 }
      this.$refs.popup.close()
    },
    
    init() {
      this.popupLoading = true
      //清除等待
      this.confirmLoading = false
      //清空内容
      this.formParameter = { vsite: 1 }
 
      //清楚校验
      this.$refs.form.clearValidate()

      if (this.parameter && this.parameter.id) {
        //编辑查询数据
        let parameter = {
          id: this.parameter.id
        }
        api.toUpdate(parameter, response => {
          this.popupLoading = false
          console.log(response)
          this.formParameter = response.data

          if (this.formParameter.kid) {
            this.sbname = this.formParameter.dbColumn_kid
          }
          this.popupLoading = false
        })
      } else {
        //添加
        this.popupLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
